import { ajax } from '@/util/ajax'

const BASE_URL = '/gateway/platform-lmsapi/origination'

const OriginationApi = {
  getLoanByIdAndFeature (data, success, failure) {
    return ajax.post(
      BASE_URL + '/loan/get',
      data,
      success,
      failure
    )
  },

  getLoanFeatureData (loanId, type, feature, success, failure, isLoading) {
    return ajax.get(
      BASE_URL + '/{0}/{1}?loanId={2}'.format(feature, type, loanId),
      null,
      success,
      failure,
      { showLoading: isLoading }
    )
  },

  updateLoanFeatureData (feature, featureData, success, failure) {
    return ajax.put(
      BASE_URL + '/{0}/update'.format(feature),
      featureData,
      success,
      failure
    )
  },

  listLoanQuestionData (loanId, success, failure, isLoading) {
    return ajax.get(
      BASE_URL + '/question/list',
      {
        loanId: loanId
      },
      success,
      failure,
      { showLoading: isLoading }
    )
  },

  batchUpdateQuestionData (data, success, failure) {
    return ajax.put(
      BASE_URL + '/question/batch-update',
      data,
      success,
      failure
    )
  },

  getLoanPastStatusByLoanId (loanId, success, failure) {
    return ajax.get(
      BASE_URL + '/loan-status/past-status?loanId={0}'.format(loanId),
      null,
      success,
      failure
    )
  },

  getIndicatorByLoanId (loanId, success, failure) {
    return ajax.get(
      BASE_URL + '/indicator/list?loanId={0}'.format(loanId),
      null,
      success,
      failure
    )
  },

  initiateLoanIndicator (loanId, loanNo, success, failure) {
    return ajax.post(
      BASE_URL + '/indicator/initiate',
      { loanId: loanId },
      success,
      failure
    )
  },

  updateApplicationIndicator (data, success, failure) {
    return ajax.put(
      BASE_URL + '/indicator/batch-update',
      data,
      success,
      failure
    )
  },

  addDialData (loanId, success, failure) {
    return ajax.post(
      BASE_URL + '/dial/increase',
      { loanId: loanId },
      success,
      failure
    )
  },

  getDialData (loanId, success, failure) {
    return ajax.get(
      BASE_URL + '/dial/count',
      { loanId: loanId },
      success,
      failure
    )
  },

  listLoanReviewDataRelatedAssignedLoan (loanId, sectionKey, success, failure) {
    return ajax.get(
      BASE_URL + '/review/list',
      {
        loanId,
        sectionKey
      },
      success,
      failure
    )
  },

  batchUpdateLoanReviewData (reviewData, success, failure) {
    return ajax.put(
      BASE_URL + '/review/batch-update',
      reviewData,
      success,
      failure
    )
  },

  getLoanSignData (loanId, success, failure) {
    return ajax.get(
      BASE_URL + '/sign-status/get',
      {
        loanId: loanId
      },
      success,
      failure
    )
  },

  addDocumentData (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/loan-document/add`,
      data,
      success,
      failure
    )
  },

  listDocumentData (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/loan-document/list`,
      data,
      success,
      failure
    )
  },

  updateLoanQualityData (data, success, failure) {
    return ajax.put(
      `${BASE_URL}/quality/update`,
      data,
      success,
      failure
    )
  },

  updateLoanBankRecordsData (data, success, failure) {
    return ajax.put(
      BASE_URL + '/statement/batch-update',
      data,
      success,
      failure
    )
  },

  getPaymentFrequencyByLoanId (data, success, failure) {
    return ajax.get(
      BASE_URL + '/employment/get',
      data,
      success,
      failure
    )
  },

  getIBVDataByLoanId (loanId, success, failure) {
    return ajax.get(
      BASE_URL + '/ibv/get',
      { loanId: loanId },
      success,
      failure
    )
  },

  updateIBVDataByLoanId (data, success, failure) {
    return ajax.put(
      BASE_URL + '/ibv/update',
      data,
      success,
      failure
    )
  },

  updateSection (data, success, failure) {
    return ajax.put(
      `${BASE_URL}/section/update-section`,
      data,
      success,
      failure
    )
  },

  getLoanOperationByLoanId (loanId, success, failure) {
    return ajax.get(
      BASE_URL + '/operation/get',
      { loanId: loanId },
      success,
      failure
    )
  },

  addSectionFeature (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/section/add-feature`,
      data,
      success,
      failure
    )
  },

  getSectionFeature (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/section/get-feature`,
      data,
      success,
      failure
    )
  },

  listSectionFeature (data, success, failure) {
    const config = { headers: { 'List-Headers': JSON.stringify(data.feature) } }
    return ajax.postHeader(
      BASE_URL + '/section/list-feature',
      data,
      success,
      failure,
      config
    )
  },

  updateSectionFeature (data, success, failure) {
    return ajax.put(
      BASE_URL + '/section/update-feature',
      data,
      success,
      failure
    )
  },

  getFollowUpByLoanId (loanId, success, failure) {
    return ajax.get(
      BASE_URL + '/follow-up/get',
      { loanId: loanId },
      success,
      failure
    )
  },

  getExpressSourceLoan (loanId, success, failure) {
    return ajax.get(
      BASE_URL + '/express-source/loan/get',
      { loanId: loanId },
      success,
      failure
    )
  },

  enableSpecialConsideration (input, success, failure) {
    return ajax.post(
      BASE_URL + '/special-consideration/enable',
      input,
      success,
      failure
    )
  },

  getSpecialConsideration (input, success, failure) {
    return ajax.get(
      BASE_URL + '/special-consideration/get',
      input,
      success,
      failure
    )
  },

  disableSpecialConsideration (input, success, failure) {
    return ajax.put(
      BASE_URL + '/special-consideration/disable',
      input,
      success,
      failure
    )
  }
}

export { OriginationApi }
